// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * ChatExpiryReminderModal Styles
 */

/* Overlay */
.chat-expiry-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  box-sizing: border-box;
}

/* Modal container */
.chat-expiry-modal {
  background: #FFFFFF;
  border-radius: 20px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  width: 560px;
  max-width: 90vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  font-family: 'Open Sans', sans-serif;
  overflow: hidden;
}

/* Header */
.chat-expiry-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 24px 24px 12px 24px;
  position: relative;
}

.chat-expiry-header-icon {
  font-size: 24px;
  line-height: 1;
}

.chat-expiry-title {
  margin: 0;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #2E2E2E;
  flex: 1;
}

.chat-expiry-close {
  position: absolute;
  right: 15px;
  top: 15px;
  background: #4A4A4A;
  border: none;
  font-size: 20px;
  color: #FFFFFF;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  line-height: 1;
}

.chat-expiry-close:hover {
  background: #333333;
}

/* Description */
.chat-expiry-description {
  margin: 0;
  padding: 0 24px 16px 24px;
  font-size: 14px;
  color: #6A6A6A;
  line-height: 1.5;
}

/* Room list */
.chat-expiry-list {
  flex: 1;
  overflow-y: auto;
  border-top: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;
}

.chat-expiry-room-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-bottom: 1px solid #F0F0F0;
  gap: 12px;
}

.chat-expiry-room-row:last-child {
  border-bottom: none;
}

.chat-expiry-room-row:hover {
  background: #FAFAFA;
}

.chat-expiry-room-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.chat-expiry-room-name {
  font-size: 15px;
  font-weight: 600;
  color: #2E2E2E;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Expiry badges */
.expiry-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  width: fit-content;
}

.expiry-badge--critical {
  background: #FEE2E2;
  color: #DE4858;
}

.expiry-badge--warning {
  background: #FEF3C7;
  color: #D97706;
}

.expiry-badge--info {
  background: #EFF6FF;
  color: #3B82F6;
}

/* Leave button */
.chat-expiry-leave-btn {
  flex-shrink: 0;
  background: #F3F4F6;
  color: #374151;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.chat-expiry-leave-btn:hover:not(:disabled) {
  background: #DE4858;
  color: #FFFFFF;
  border-color: #DE4858;
}

.chat-expiry-leave-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Footer */
.chat-expiry-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
}

.chat-expiry-close-btn {
  background: #D8D8D8;
  color: #6A6A6A;
  border: none;
  border-radius: 10px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  height: 40px;
  padding: 0 24px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.chat-expiry-close-btn:hover {
  background: #CDCCCD;
}

/* Responsive */
@media (max-width: 480px) {
  .chat-expiry-modal {
    width: 100%;
    max-height: 85vh;
    border-radius: 20px 20px 0 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .chat-expiry-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .chat-expiry-room-row {
    padding: 12px 16px;
  }

  .chat-expiry-footer {
    padding: 12px 16px;
  }

  .chat-expiry-close-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal/ChatExpiryReminderModal.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,OAAO;EACP,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;EACV;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/**\n * ChatExpiryReminderModal Styles\n */\n\n/* Overlay */\n.chat-expiry-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Modal container */\n.chat-expiry-modal {\n  background: #FFFFFF;\n  border-radius: 20px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);\n  width: 560px;\n  max-width: 90vw;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Open Sans', sans-serif;\n  overflow: hidden;\n}\n\n/* Header */\n.chat-expiry-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 24px 24px 12px 24px;\n  position: relative;\n}\n\n.chat-expiry-header-icon {\n  font-size: 24px;\n  line-height: 1;\n}\n\n.chat-expiry-title {\n  margin: 0;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #2E2E2E;\n  flex: 1;\n}\n\n.chat-expiry-close {\n  position: absolute;\n  right: 15px;\n  top: 15px;\n  background: #4A4A4A;\n  border: none;\n  font-size: 20px;\n  color: #FFFFFF;\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n  transition: background 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  line-height: 1;\n}\n\n.chat-expiry-close:hover {\n  background: #333333;\n}\n\n/* Description */\n.chat-expiry-description {\n  margin: 0;\n  padding: 0 24px 16px 24px;\n  font-size: 14px;\n  color: #6A6A6A;\n  line-height: 1.5;\n}\n\n/* Room list */\n.chat-expiry-list {\n  flex: 1;\n  overflow-y: auto;\n  border-top: 1px solid #E5E5E5;\n  border-bottom: 1px solid #E5E5E5;\n}\n\n.chat-expiry-room-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 24px;\n  border-bottom: 1px solid #F0F0F0;\n  gap: 12px;\n}\n\n.chat-expiry-room-row:last-child {\n  border-bottom: none;\n}\n\n.chat-expiry-room-row:hover {\n  background: #FAFAFA;\n}\n\n.chat-expiry-room-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.chat-expiry-room-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: #2E2E2E;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Expiry badges */\n.expiry-badge {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 12px;\n  width: fit-content;\n}\n\n.expiry-badge--critical {\n  background: #FEE2E2;\n  color: #DE4858;\n}\n\n.expiry-badge--warning {\n  background: #FEF3C7;\n  color: #D97706;\n}\n\n.expiry-badge--info {\n  background: #EFF6FF;\n  color: #3B82F6;\n}\n\n/* Leave button */\n.chat-expiry-leave-btn {\n  flex-shrink: 0;\n  background: #F3F4F6;\n  color: #374151;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 14px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n\n.chat-expiry-leave-btn:hover:not(:disabled) {\n  background: #DE4858;\n  color: #FFFFFF;\n  border-color: #DE4858;\n}\n\n.chat-expiry-leave-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Footer */\n.chat-expiry-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px;\n}\n\n.chat-expiry-close-btn {\n  background: #D8D8D8;\n  color: #6A6A6A;\n  border: none;\n  border-radius: 10px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  height: 40px;\n  padding: 0 24px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.chat-expiry-close-btn:hover {\n  background: #CDCCCD;\n}\n\n/* Responsive */\n@media (max-width: 480px) {\n  .chat-expiry-modal {\n    width: 100%;\n    max-height: 85vh;\n    border-radius: 20px 20px 0 0;\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n  }\n\n  .chat-expiry-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .chat-expiry-room-row {\n    padding: 12px 16px;\n  }\n\n  .chat-expiry-footer {\n    padding: 12px 16px;\n  }\n\n  .chat-expiry-close-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
